export const HTS_CODE_NOT_ON_FILE = 'HTS_CODE_NOT_ON_FILE';
export const ENTITY_IDENTIFIER_NOT_ON_FILE = 'ENTITY_IDENTIFIER_NOT_ON_FILE';
export const FILER_CODE_NOT_AUTHORIZED = 'FILER_CODE_NOT_AUTHORIZED';
export const IMPORTER_NOT_FOUND = 'IMPORTER_NOT_FOUND';
export const CONSIGNEE_NOT_FOUND = 'CONSIGNEE_NOT_FOUND';
export const MANUFACTURER_NOT_FOUND = 'MANUFACTURER_NOT_FOUND';

export const CBP_MESSAGE = (key: string) => `CBP_MESSAGES.${key}`;
